import {Route} from "../../../registry/routes.js"
import externalPluginDialog from "../../../components/core/ExternalPluginDialog.vue";

const r = new Route("external-plugin-manager", "externalplugin", {"external-plugin-manager":externalPluginDialog}, {componentType:"bin_modal_component",title:"Plugins"}, [], true, null)

export default r